import { DataTable } from "@/components/data-table";
import useMonetizacion from "@/features/monetizacion/hooks/use-monetizacion";
import { formatDate, formatNumber } from "@/shared/formats";
import { Compra } from "@/shared/types/compra";
import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

export default function CompraView({
    compra
}: {
    compra: Compra
}) {
    const { monedaBase } = useMonetizacion();

    return <Stack gap={3} padding={3} flex={1}>
        <Stack gap={1}>
            <Typography variant="h6">Información General</Typography>
            <AttributeValuePair label={"Fecha: "} value={formatDate(compra.fecha)} />
            <AttributeValuePair label={"N° de Comprobante: "} value={compra.numComprobante} />
            <AttributeValuePair label={"Proveedor: "} value={compra.proveedorNombre} />
        </Stack>
        <Stack gap={2} flex={1}>
            <Typography variant="h6">Artículos</Typography>
            <DataTable flex={1}>
                <DataTable.Content
                    fit="flex"
                    columns={[
                        { header: "Código", render: i => i.articuloCodigo },
                        { header: "Artículo", render: i => i.articuloNombre },
                        { header: "Costo Unitario", render: i => formatNumber(i.costoUnitario), align: "right" },
                        { header: "Cantidad (Uds.)", render: i => formatNumber(i.cantidad), align: "right" },
                        { header: `Subtotal (${monedaBase.simbolo})`, render: i => formatNumber(i.costoUnitario * i.cantidad), align: "right" }
                    ]}
                    rows={compra.items}
                    footers={[
                        { render: () => <Typography variant="subtitle1">Total: </Typography>, span: 3 },
                        { render: () => <Typography variant="subtitle2">{formatNumber(compra.items.reduce((p, v) => p + v.cantidad, 0))}</Typography>, align: "right" },
                        { render: () => <Typography variant="subtitle2">{formatNumber(compra.items.reduce((p, v) => p + v.cantidad * v.costoUnitario, 0))}</Typography>, align: "right" }
                    ]}
                />
            </DataTable>
        </Stack>
    </Stack>
}

// function VmcIeImage({
//     id,
//     size
// }: {
//     id: number,
//     size: number
// }) {
//     const handleGetImage = async () => {
//         return await ArticulosService.getImage(id);
//     }

//     const sizePx = size + "px";

//     return <Stack width={sizePx} height={sizePx} alignItems={"center"} justifyContent={"center"}>
//         <AsyncImage fetch={handleGetImage} width={(size - 10) + "px"} />
//     </Stack>
// }

function AttributeValuePair({
    label,
    value
}: {
    label: ReactNode,
    value: ReactNode
}) {
    return <Stack direction={"row"} gap={2} marginLeft={5}>
        <Typography variant="subtitle2">{label}</Typography>
        <Typography variant="body2">{!value && value !== 0 ? "---" : value}</Typography>
    </Stack>
}
